import React, { useEffect } from 'react'
import { AppCrudTable } from '@components'
import ReportTableCreateReportButton from 'Pages/ReportsAlerts/Reports/@components/CrudTable/CreateReport'
import { useManageStatusMultiple, useReportBackendApiPath, useReportTableData } from 'Pages/ReportsAlerts/Reports/@hooks'
import { capitalize, Skeleton } from '@mui/material'
import { actionsColumn, airportsColumn, dateColumn, frequencyColumn, frequencyHoursColumn, numSearchColumn, reportNameColumn, sitesColumn, statusColumn } from './columns'
import { reportListData, reportListStatusFilter } from '../../@signals'
import ReportListTableCustomToolbarSelect from './MultiToolbar'
import { getExcel } from '@ui-seeker/utils'


export default function ReportCrudTable() {
	const { isLoadingReportList, getTableContentData } = useReportTableData()
	const { reportType, backendUrl } = useReportBackendApiPath()

	useEffect(() => {
		getTableContentData()
	}, [])

	useManageStatusMultiple()

	if (isLoadingReportList) return <Skeleton variant="rectangular" height={500}/>

	return <AppCrudTable
		title={`Reports ${capitalize(reportType)} List`}
		data={reportListData.value}
		columns={[
			...reportNameColumn(),
			numSearchColumn(),
			...sitesColumn(),
			frequencyHoursColumn(),
			frequencyColumn(),
			...airportsColumn(),
			...dateColumn(!!reportType),
			...statusColumn(),
			actionsColumn()]}
		options={{
			selectableRows: 'multiple',
			customToolbarSelect: (selectedData, setSelectedRows) => <ReportListTableCustomToolbarSelect
				selectedData={selectedData}
				setSelectedRows={setSelectedRows}
			/>,
			customToolbar: () => <ReportTableCreateReportButton/>,
			onFilterChange: (changedColumn, filterList, _, dataIdx) => {
				if (changedColumn === 'enabled')
					reportListStatusFilter.value = filterList[dataIdx]
			},
			onDownload: () => getExcel(`${backendUrl}/list/excel`, {}),
		}}
	/>
}